<template>
    <v-dialog v-model="localDialog" :max-width="maxWidth">
        <v-card class="rounded-lg">
            <v-progress-linear
                indeterminate
                :color="`${color} lighten-1`"
                class="mb-0"
            ></v-progress-linear>
            <v-card-title class="d-flex align-center">
                <span class="text-h6 font-weight-bold accent-text d-flex">{{ title }}</span>
            </v-card-title>           
            <v-card-text class="d-flex"> {{ description }} </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :color="`${color} darken-1`" text @click="confirm"> {{ confirmButtonText }} </v-btn>
                <v-btn color="grey darken-1" text @click="cancel"> {{ cancelButtonText }} </v-btn>
            </v-card-actions>
            <v-progress-linear
                indeterminate
                color="grey lighten-2"
                class="mb-0"
            ></v-progress-linear>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: "Confirm",
        },
        description: {
            type: String,
            required: false,
            default: "Are you sure?",
        },
        confirmButtonText: {
            type: String,
            required: false,
            default: "Yes",
        },
        cancelButtonText: {
            type: String,
            required: false,
            default: "No",
        },
        icon: {
            type: String,
            required: false,
            default: "mdi-check-circle-outline",
        },
        dialog: {
            type: Boolean,
            required: false,
            default: false,
        },
        maxWidth: {
            type: String,
            required: false,
            default: "290",
        },
        color: {
            type: String,
            required: false,
            default: "primary",
        },
    },
    data() {
        return {
            localDialog: this.dialog,
        }
    },
    methods: {
        confirm() {
            this.$emit("confirm");
            this.localDialog = false;   
        },
        cancel() {
            this.$emit("cancel");
            this.localDialog = false;
        },
    },
    watch: {
        dialog(newVal) {
            this.localDialog = newVal;
        },
        localDialog(newVal) {
            this.$emit('update:dialog', newVal);
        }
    },
}
</script>